import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { AlertaMantenimientoACostoModelo } from '../../../modelos/AlertaMantenimientoACosto';
import type { IAlertaMantenimientoACosto } from '../../../modelos/AlertaMantenimientoACosto/entidades/IAlertaMantenimientoACosto';
import { EnumPerfiles } from '../../enums/enumPerfiles';
import { EnumTipoNotificacion } from '../../interfaces';
import type { INotificacion, IOrigenNotificaciones, TipoNotificacion } from './interfaces';

dayjs.extend(utc);

const PREFIJO_MANTENIMIENTO = 'mantenimientoACosto-';

/** "Crea la tarea de mantenimiento a costo del equipo X – Nombre del proyecto Y (mes 3 de 6)." */
const notificacionMantenimiento = (alerta: IAlertaMantenimientoACosto): INotificacion => {
    const equipo = alerta.Equipo.Nombre ? `${alerta.Equipo.Codigo} – ${alerta.Equipo.Nombre}` : alerta.Equipo.Codigo;
    const proyecto = alerta.Proyecto ? ` del proyecto ${alerta.Proyecto.Nombre}` : '';
    return {
        Clave: `${PREFIJO_MANTENIMIENTO}${alerta.Id}`,
        Tipo: 'mantenimientoACosto',
        Titulo: 'Mantenimiento a costo',
        Mensaje: `Crea la tarea de mantenimiento a costo del equipo ${equipo}${proyecto} (mes ${alerta.MesActual} de ${alerta.MesesPactados}).`,
        // Llega en UTC sin zona: se interpreta como UTC y se pasa a la hora local.
        Fecha: dayjs.utc(alerta.FechaAlerta).local().toDate(),
        Leida: alerta.Leida
    };
};

/** Alertas mensuales de mantenimiento a costo: solo el Analista, que programa esas tareas. */
const mantenimientoACosto: IOrigenNotificaciones = {
    aplica: (roles) => roles.includes(EnumPerfiles.Analista),
    contarNoLeidas: async () => ((await new AlertaMantenimientoACostoModelo().listar(true)).Data ?? []).length,
    listar: async () => ((await new AlertaMantenimientoACostoModelo().listar()).Data ?? []).map(notificacionMantenimiento),
    marcarLeida: async (notificacion) => {
        const id = Number(notificacion.Clave.slice(PREFIJO_MANTENIMIENTO.length));
        const respuesta = await new AlertaMantenimientoACostoModelo().marcarLeida(id);
        return respuesta?.NotificationType !== EnumTipoNotificacion.Error;
    }
};

/** Todos los orígenes de la campana, por tipo (para marcar cada notificación en el suyo). Uno nuevo se agrega aquí. */
export const ORIGENES_NOTIFICACIONES: Record<TipoNotificacion, IOrigenNotificaciones> = { mantenimientoACosto };
